import { ESREquipmentServiceColumns } from "./types";
import * as yup from "yup";

export const ESRESInitialValues: ESREquipmentServiceColumns = {
  id: "",
  taskItem: "",
  taskTypeId: "",
  taskTypeItem: "",
  partNumber: "",
  quantity: "",
  remarks: "",
};

export const ESRESSchema = yup.object({
  id: yup.string().nullable(),
  taskItem: yup.string().required("Item is required"),
  taskTypeId: yup.string(),
  taskTypeItem: yup.string().required("Task type is required"),
  partNumber: yup.string(),
  quantity: yup
    .number()
    .typeError('Must be a number')
    .min(0, 'Must be 0 or more'),
  remarks: yup.string().required("Remarks is required"),
});
